import { LoaderService } from './../../../_services/loader.service';
import { LocationService } from './../../../_services/location.service';
import { CmsService } from './../../../_services/strapi.service';
import { MerchantService } from 'src/app/_services/merchant.service';
import { Component, inject, OnInit } from '@angular/core';
import { File, Pdf } from 'src/app/_models/strapi-file';
import { saveAs } from 'file-saver';

@Component({
    selector: 'app-documents',
    templateUrl: './documents.component.html',
    styleUrls: ['./documents.component.scss'],
    standalone: false
})

export class DocumentsComponent implements OnInit {
  private readonly cmsService: CmsService = inject(CmsService);
  private readonly locationService: LocationService = inject(LocationService);
  private readonly loaderService: LoaderService = inject(LoaderService);
  
  public merchantService: MerchantService = inject(MerchantService);

  listPdfHome: Array<Pdf>;
  currentLanguage: string;

  ngOnInit(): void {
    this.loaderService.startLoader();
    this.cmsService.getDocuments().subscribe(
      response => {
        this.listPdfHome = response.filter(pdf => pdf.visibility === 'home');
        this.loaderService.stopLoader();
      },
      error => this.loaderService.stopLoader()
    );

    this.locationService.currentLanguage$.subscribe(resp => this.currentLanguage = resp);
  }

  openPdf(file: File) {

    if(!file) {
      return;
    } else {
      this.cmsService.downloadFile(file.url).subscribe(blob => {
        saveAs(blob, `${file.name}`);
      }
    );
    }

  }

  navigateToSandbox() {
    let href = window.location.href.split('/');
    let ix = href.indexOf('public');
    if (ix === -1) {return; }
    href.splice(ix);
    href.push('sandbox');
    window.location.href = href.join('/');
  }

}
